<template>
  <div>
    <base-card>
      <custom-form ref="customerForm">
        <base-label text="Informações do cliente" class="mb_30" />
        <name-input ref="name" v-model="newCustomer.name" autocomplete="none" />
        <telephone-input
          v-model="newCustomer.phone"
          :disabled="!!customer.id"
          autocomplete="none"
        />
        <email-input
          v-model="newCustomer.email"
          :required="false"
          autocomplete="none"
        />
        <birthday-input
          v-model="newCustomer.birthdate"
          :required="false"
          autocomplete="none"
        />
        <div style="display: flex; justify-content: flex-end; margin-top: 25px">
          <p class="show-more" @click="showTermLGPD = !showTermLGPD">
            {{ showTermLGPD ? 'Ver menos' : 'Ver mais' }}
          </p>
        </div>
        <base-checkbox
          v-if="!!showTermLGPD"
          :checked="lgpdTermDissalowed"
          v-model="lgpdTermDissalowed"
          class="mt_25"
        >
          <p class="text-checkbox">Não enviar e-mails e SMS'S promocionais.</p>
        </base-checkbox>
      </custom-form>
    </base-card>

    <base-card class="pt_20 pb_20">
      <base-textarea
        class="mb_5"
        rows="4"
        v-model="annotation.annotation"
        design="four"
        label="Anotações"
      />
    </base-card>

    <div
      v-for="(address, addressIndex) in addresses.filter((a) => !a.deleted)"
      :key="`${addressIndex}`"
    >
      <div v-if="!address.deleted">
        <base-card
          class="relative"
          v-if="address.id"
          :key="`addrCard-${addressIndex}`"
        >
          <base-label :text="`Endereço ${addressIndex + 1}`" class="mb_25" />
          <span
            class="delete-address cursor-pointer"
            @click="removeAddress(addressIndex)"
          >
            <i class="fal fa-times"></i>
          </span>

          <p class="mb_5" style="font-size: 1.2em; line-height: 17px">
            {{ formatAddressString(address) }}
          </p>
        </base-card>

        <base-card
          v-else
          class="relative pb_10"
          :key="`addrForm-${addressIndex}`"
        >
          <base-label :text="`Novo endereço`" class="mb_20" />
          <span
            class="delete-address cursor-pointer"
            @click="removeAddress(addressIndex, false)"
          >
            <i class="fal fa-times"></i>
          </span>

          <address-input
            placeholder="Buscar endereço e número"
            @selectedAddress="
              (option) => onAddressSelected(option, addressIndex)
            "
            :disabled="!!address.geolocation"
          />

          <!-- Esta div só aparece quando um endereço for selecionado no select acima -->
          <div v-if="!!address.geolocation">
            <div class="row">
              <div class="col-lg-12 col-xs-12">
                <base-input label="Complemento" v-model="address.complement" />
              </div>
              <div class="col-lg-12 col-xs-12">
                <base-input
                  label="Ponto de referência"
                  v-model="address.observation"
                />
              </div>
            </div>
          </div>
        </base-card>
      </div>
    </div>
    <base-card>
      <base-add
        :text="'Endereço'"
        :height="'120px'"
        class="mb_30"
        @click.native="pushAddress"
        design="two"
      />
    </base-card>
  </div>
</template>

<script>
import Vue from 'vue';
import { LGPD } from 'easyjs/lib/Schema/Account/User';

import BaseCheckbox from '@/components/Checkbox';
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
import BaseButton from '@/components/Button';
import BaseAdd from '@/components/Add';
import BaseLabel from '@/components/Label';
import BaseTextarea from '@/components/Textarea';
import BaseInput from '@/components/Input';

import Customer from '@/containers/Customer';
import CustomForm from '@/containers/Form';
import AddressInput from '@/containers/AddressInput';
import NameInput from '@/containers/Inputs/NameInput';
import TelephoneInput from '@/containers/Inputs/TelephoneInput';
import EmailInput from '@/containers/Inputs/EmailInput';
import BirthdayInput from '@/containers/Inputs/BirthdayInput';

import Utils from '@/utils';

import Location from '@/plugins/core/schema/configurations/BasicInfo/Location';

export default {
  props: {
    configurations: {},
    role: {},
    customer: {},
  },
  data() {
    return {
      Location,
      Utils,
      editCustomer: false,
      newCustomer: {},
      addresses: [],
      annotation: { annotation: null },
      lastScheduledSearch: [],
      addressString: [],
      addressOptions: [],
      lgpdTermDissalowed: false,
      showTermLGPD: false,
    };
  },
  components: {
    BaseCard,
    BaseQuestion,
    BaseButton,
    BaseAdd,
    BaseLabel,
    BaseTextarea,
    AddressInput,
    BaseInput,
    Customer,
    CustomForm,
    NameInput,
    TelephoneInput,
    EmailInput,
    BirthdayInput,
    EmailInput,
    BaseCheckbox,
  },
  created() {
    if (Object.keys(this.customer).length > 0) {
      const baseCostumer = {
        name: '',
        email: '',
        phone: '',
        ...this.customer,
        ...{
          birthdate: this.customer.birthdate
            ? Utils.db2date(this.customer.birthdate)
            : '',
        },
      };
      this.newCustomer = baseCostumer;
    }
  },
  mounted() {
    if (!this.customer.name) {
      // pega referência de input de nome para dar foco
      this.$refs.name.$refs.baseinput.focus();
    }

    this.newCustomer = JSON.parse(JSON.stringify(this.customer));

    if (this.newCustomer.phone) {
      this.newCustomer.phone = this.newCustomer.phone.replace(
        /[\(\)\-\ ]*/g,
        ''
      );
    }

    if (this.newCustomer.birthdate) {
      this.newCustomer.birthdate = Utils.db2date(this.newCustomer.birthdate);
    }

    if (!this.newCustomer.annotation) {
      this.newCustomer.annotation = { annotation: '' };
    }

    this.lgpdTermDissalowed = !this.newCustomer.lgpd;
    this.addresses = this.newCustomer.addresses
      ? Object.clone(this.newCustomer.addresses)
      : [];
    this.annotation = this.newCustomer.annotation
      ? Object.clone(this.newCustomer.annotation)
      : { annotation: null };
  },
  methods: {
    formatAddressString(location, inverseNumber = false) {
      let addressString = `${location.address}${
        location.number !== 'null' ? `, ${location.number}` : ''
      }`;

      if (inverseNumber) {
        addressString = `${location.number ? `${location.number}, ` : ''}${
          location.address
        }`;
      }

      if (location.region || location.city) {
        addressString += ` - ${
          location.region
            ? `${location.region}${location.city ? `, ${location.city}` : ''}`
            : `${location.city}`
        }`;
      }

      if (location.state || location.country) {
        addressString += ` - ${
          location.state
            ? `${location.state}${
                location.country ? `, ${location.country}` : ''
              }`
            : `${location.country}`
        }`;
      }

      if (location.zipcode) {
        addressString += ` - ${location.zipcode}`;
      }

      return addressString;
    },
    onAddressSelected(option, index) {
      if (option.address) {
        this.addresses[index] = Location.fromObject(option.address);
        this.$forceUpdate();
      }
    },
    removeAddress(index) {
      const self = this;
      confirm('Deseja apagar o endereço?', (response) => {
        if (response) {
          self.addresses.filter((a) => !a.deleted)[index].deleted = true;
          this.newCustomer.addresses = self.addresses;
          self.$forceUpdate();
        }
      });
    },
    pushAddress(index) {
      this.addresses.push(new Location());
      this.newCustomer.addresses = this.addresses;
    },
    save() {
      const { newCustomer, lgpdTermDissalowed } = this;

      if (!newCustomer.name || !newCustomer.name.trim()) {
        return alert('Nome não informado!');
      }

      if (!newCustomer.phone || !newCustomer.phone.trim()) {
        return alert('Número não informado!');
      }

      if (newCustomer.phone.length < 10 || newCustomer.phone.length > 11) {
        return alert('Telefone inválido! Verifique a quantidade de dígitos.');
      }

      this.$refs.customerForm.validateInputs();
      if (this.$refs.customerForm.messages.length) {
        return alert('Verique os dados informados.');
      }

      newCustomer.phone = newCustomer.phone.replace(/[\(\)\-\ ]*/g, '');
      newCustomer.lgpd = lgpdTermDissalowed ? null : LGPD.EMAIL + LGPD.SMS;
      newCustomer.addresses = this.addresses;
      newCustomer.annotation = this.annotation;

      if (
        newCustomer.addresses < 0 &&
        !newCustomer.addresses[newCustomer.addresses.length - 1].address
      ) {
        newCustomer.addresses.pop();
      }

      this.$emit('save', newCustomer);
    },
  },
  watch: {
    customer: {
      deep: true,
      handler(newValue) {
        if (newValue.id) {
          this.newCustomer.id = newValue.id;
        }

        Vue.set(this, 'addresses', Object.clone(newValue.addresses || []));
        Vue.set(
          this,
          'annotation',
          Object.clone(newValue.annotation || { annotation: null })
        );
      },
    },
  },
};
</script>

<style scoped>
.info-customer-address,
.notes-text {
  padding: 5px;
  font-size: 1.4em;
  color: #999;
  font-weight: 300;
}

.show-more {
  border: none;
  background: none;
  cursor: pointer;
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
  font-weight: 400;
  padding-bottom: 3px;
  border-bottom: 1px solid #fff;
  font-size: 1.2em;
  color: #fff;
}

.delete-address {
  position: absolute;
  top: 26px;
  right: 0;
  font-size: 1.4em;
  color: #aaaaab;
  cursor: pointer;
  padding: 5px;
}
</style>
